import produce from 'immer'

import { TARGETED_DB_FLASH } from '../action-types'
import { TARGETED_DB_FLASH_INITIAL_STATE } from '../initial-states'

const targetedDbFlashReducer = (
  state = TARGETED_DB_FLASH_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case TARGETED_DB_FLASH.START:
      return produce(state, nextState => {
        nextState.isLoading = true
      })

    case TARGETED_DB_FLASH.COMPLETE:
      return produce(state, nextState => {
        nextState.isLoading = false
        nextState.data = action.payload.data.startTargetedDbFlash
      })

    case TARGETED_DB_FLASH.FAIL:
      return produce(state, nextState => {
        nextState.isLoading = false
        nextState.error = action.payload.error
      })

    default:
      return state
  }
}

export default targetedDbFlashReducer
